import {StateGapMapDataset} from './types';

export const stateGapMapData: StateGapMapDataset = {
  tiers: [
    {
      id: 'lagging',
      label: 'Lagging',
    },
    {
      id: 'progressing',
      label: 'Progressing',
    },
    {
      id: 'leading',
      label: 'Leading',
    },
  ],
  states: [
    {
      id: 'al',
      code: 'AL',
      name: 'Alabama',
      tier: 'leading',
      accessPercent: 92,
      participationPercent: 7.9,
      reportUrl:
        'https://drive.google.com/file/d/1LjKk5IE5BA_5iCVUPBNQrYexjQHsLpdF/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/16ruhsWynfipqDj0oZh1WMZ6JNjz6OMrL4zD43q3g818/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ak',
      code: 'AK',
      name: 'Alaska',
      tier: 'lagging',
      accessPercent: 34,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1HsLGphsUQc2Leq_Hj_HIpxSwsFH-rcmr/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/11gYHc8oMZFFL3fiEoZC1XOrllvK_10soMKpp-NDcYHw/copy',
      isSelectable: true,
      displayRegion: 'alaskaInset',
    },
    {
      id: 'az',
      code: 'AZ',
      name: 'Arizona',
      tier: 'lagging',
      accessPercent: 43,
      participationPercent: 3.8,
      reportUrl:
        'https://drive.google.com/file/d/11PsBSL_6H0VMc3sFqTHiCSfv4guTOAAE/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1RYnEMtib9fNd2QL-_Ku3f23_ObfhVnMLl8Z5-jXv_8Y/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ar',
      code: 'AR',
      name: 'Arkansas',
      tier: 'leading',
      accessPercent: 100,
      participationPercent: 25.1,
      reportUrl:
        'https://drive.google.com/file/d/1j_PmlzKjv0__ELmjr_ld01n1BcaSTx3B/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1C2w4pvg-QtZkwid6nXoKedprktOqGzgufdQVEXn4MDU/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ca',
      code: 'CA',
      name: 'California',
      tier: 'lagging',
      accessPercent: 58,
      participationPercent: 5.3,
      reportUrl:
        'https://drive.google.com/file/d/1egSA2K-JT20PnGjQvOus96mA7ueYsCBO/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1INzrQvbB5BAYCa3PQdP7CeYT1qi_o56LoQewVH67rn4/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'co',
      code: 'CO',
      name: 'Colorado',
      tier: 'progressing',
      accessPercent: 66,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1r65Ldlk1R7Pg1b-eVPOi38z7-J2iRVWo/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1k0nR7ytehLmtJvzCShQjVp3CLa6AHUImocIZYYllQ3w/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ct',
      code: 'CT',
      name: 'Connecticut',
      tier: 'leading',
      accessPercent: 84,
      participationPercent: 7.5,
      reportUrl:
        'https://drive.google.com/file/d/1mTMzpw-IVcRkmIvjqFj5AkXKr079V36S/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1JL5dEiyUR3kqMPb-ENoKjQzXPUFaIcazHgp1nAiKeEc/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'de',
      code: 'DE',
      name: 'Delaware',
      tier: 'progressing',
      accessPercent: 63,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1ovZbNHST7QShaSBTFv_yXGYZyXY_Vyht/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1kfK91xdTvCGnO7aCOCQcPfvr0pU6tOf8uJ0EqFruo0A/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'fl',
      code: 'FL',
      name: 'Florida',
      tier: 'lagging',
      accessPercent: 39,
      participationPercent: 2.3,
      reportUrl:
        'https://drive.google.com/file/d/1_Cv8KLEzFzY5V3qzzBRGdHt76vDFRQh3/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1nqFA7QfYfnYn_jypaKC5F5TnpmE3wZd8sc_JUr9XTpw/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ga',
      code: 'GA',
      name: 'Georgia',
      tier: 'leading',
      accessPercent: 81,
      participationPercent: 8,
      reportUrl:
        'https://drive.google.com/file/d/1zrFNoaELqwRK3cKECmMB_ptVlMh86PCC/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/14nFIGiUDmLw2LQwCwM9EmD-iNpX8VubPGclOiYttx4I/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'hi',
      code: 'HI',
      name: 'Hawaii',
      tier: 'progressing',
      accessPercent: 67,
      participationPercent: 2.5,
      reportUrl:
        'https://drive.google.com/file/d/1NZVhDisb0-Hq1uhHG5jTspEsIjTCKNiO/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1dgq-ypSGLwLvMiBQWa-6G146NvE9yg6HWWVEYaKZye4/copy',
      isSelectable: true,
      displayRegion: 'hawaiiInset',
    },
    {
      id: 'id',
      code: 'ID',
      name: 'Idaho',
      tier: 'lagging',
      accessPercent: 44,
      participationPercent: 1.8,
      reportUrl:
        'https://drive.google.com/file/d/1ci1DpJSO1_-UFxvi89AYmcPdQn11_eUA/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1BB93BuQmI_P4-8NMJCE1tuDeIl6rm5jQBGWloQNKGaI/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'il',
      code: 'IL',
      name: 'Illinois',
      tier: 'lagging',
      accessPercent: 58,
      participationPercent: 6,
      reportUrl:
        'https://drive.google.com/file/d/1FCYtwOUdmYJ-6NPnyqfEMsuGbP3ECote/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1_7vPHF3vMpVlsBTiZyfNxYkh5qswFpFZ2on2eK_Pvog/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'in',
      code: 'IN',
      name: 'Indiana',
      tier: 'progressing',
      accessPercent: 89,
      participationPercent: 5.6,
      reportUrl:
        'https://drive.google.com/file/d/1BhFPpr_OSkJNJ5A30myrsfQGgeeBovYv/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1TVYPiT_1sJNT6hcYd7bM3MaQRJaqmWp_hHm4rjdDoz8/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ia',
      code: 'IA',
      name: 'Iowa',
      tier: 'progressing',
      accessPercent: 86,
      participationPercent: 5.2,
      reportUrl:
        'https://drive.google.com/file/d/1dpRW2Hdd1YbEtZhuXF6Hu7xlOPqFj3S5/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1LxoxQV5vntUYa44YyyZ9IS98uHE8DmHx3OrpwDFsTb8/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ks',
      code: 'KS',
      name: 'Kansas',
      tier: 'lagging',
      accessPercent: 38,
      participationPercent: 2.5,
      reportUrl:
        'https://drive.google.com/file/d/1GFu0QMTN0h-EghPOPOFVjJ551cQe8d9H/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1b_xzFjIxiuZhh6pVJPZVkiUChkPIKhLrfrCQWXCr-Dw/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ky',
      code: 'KY',
      name: 'Kentucky',
      tier: 'progressing',
      accessPercent: 75,
      participationPercent: 8.6,
      reportUrl:
        'https://drive.google.com/file/d/1cawD2uJALIYmSxTwxSlcFJpMkbltZFIp/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1o6HVJho0-kaHBfPB7oEVRQQxReXChWbHskg856nM1zo/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'la',
      code: 'LA',
      name: 'Louisiana',
      tier: 'lagging',
      accessPercent: 39,
      participationPercent: 2.6,
      reportUrl:
        'https://drive.google.com/file/d/1EbaiwgOz3qAkJbPzvT5X4urkVACP3qQ0/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1xH0wb50SMoujA68hsextb544uQkFRrYC7gwhfSUazoY/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'me',
      code: 'ME',
      name: 'Maine',
      tier: 'lagging',
      accessPercent: 59,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1VmnHsk6691fqEUG624iaG0vaOHdaO6ui/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1Z8kx9EK9gbIXY-yZWykDICWpzLLJoIOSG5JTE845038/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'md',
      code: 'MD',
      name: 'Maryland',
      tier: 'progressing',
      accessPercent: 100,
      participationPercent: 16.7,
      reportUrl:
        'https://drive.google.com/file/d/1qV7YesVSOiz_i0uL1MrQEvLAzQt__8kV/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/15QrpMeFJpmA7bemt_zEZtn_5WjNyYdYKYlOrJwGJU5Q/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ma',
      code: 'MA',
      name: 'Massachusetts',
      tier: 'progressing',
      accessPercent: 81,
      participationPercent: 7.9,
      reportUrl:
        'https://drive.google.com/file/d/1v-RFxI-TT9SG7jvOPCmQJTAFLANdogLj/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1a01b6WPAAm5jK9OoMXsTzPcr7X9MueGYWn__DCa4rxg/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'mi',
      code: 'MI',
      name: 'Michigan',
      tier: 'lagging',
      accessPercent: 55,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1qTeojtOwI5dSNatFSwEGc4wORB5AOHzx/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1xZISZHAsvhNq083GNyzEGrHyePPpBGkpyk9AuGBwvo0/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'mn',
      code: 'MN',
      name: 'Minnesota',
      tier: 'lagging',
      accessPercent: 34,
      participationPercent: 1.8,
      reportUrl:
        'https://drive.google.com/file/d/1jzDPkrQzOtgP-ZAso11qO1dq8FvJIe7/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1x2x3PsHvGDqBau9LZBAxM-eSqrSivONVC6WqRrwx7XI/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ms',
      code: 'MS',
      name: 'Mississippi',
      tier: 'leading',
      accessPercent: 87,
      participationPercent: 10.9,
      reportUrl:
        'https://drive.google.com/file/d/1H8aR4d5qsqXs0Avw7kTxkAQLzNmjFuhx/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1kVSJPfDuPARdj2dnxYYDaLTXMsboQOn07WIWOSqGkug/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'mo',
      code: 'MO',
      name: 'Missouri',
      tier: 'lagging',
      accessPercent: 56,
      participationPercent: 2.9,
      reportUrl:
        'https://drive.google.com/file/d/1knQj9Vno_DFgH0ydyuXb26pycHrsx04_/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1jOFJCH6SQz-O-em8xNEZMzGyriGCIHPUDZWSfe4ttew/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'mt',
      code: 'MT',
      name: 'Montana',
      tier: 'lagging',
      accessPercent: 38,
      participationPercent: 3.7,
      reportUrl:
        'https://drive.google.com/file/d/1D6Nlq3iV1kpE66XweQOdfCgyWda2uNzw/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1N-tUgSN9Rz0DuwpSMPtmyvuLf_xZ7Uy7N-iZSjgJp30/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ne',
      code: 'NE',
      name: 'Nebraska',
      tier: 'leading',
      accessPercent: 51,
      participationPercent: 4.5,
      reportUrl:
        'https://drive.google.com/file/d/1AnNs38SxaEBc3oxdH-aSbPKogdEzMrpy/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/18v6Bde-CTsvD4MueDZE6MsriI6NIOvUziY6ph3-r2dk/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'nv',
      code: 'NV',
      name: 'Nevada',
      tier: 'leading',
      accessPercent: 98,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1KCuPMDBnX_I1x3B1nfClL6NUWqiWkd6D/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1ePG6lPQQ5vh7udW5uoCPDX2IjG8vOajnp1BpuaF4OHU/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'nh',
      code: 'NH',
      name: 'New Hampshire',
      tier: 'progressing',
      accessPercent: 94,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/12CqPoZyeZvvtqadDpNMTOX3hhuf3-SLZ/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1hMsPlkQfqaIzOsI1Nd91RvQv_yDrScxTZyIn4WXg2Lw/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'nj',
      code: 'NJ',
      name: 'New Jersey',
      tier: 'progressing',
      accessPercent: 86,
      participationPercent: 8.8,
      reportUrl:
        'https://drive.google.com/file/d/1wbpXLKBqohv61Kx1Mw39VjWFAL_jAGuf/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1rSwd6LHfY1I6zPI_jn2bokkvGvgdtoNKgk-VZV1w_bI/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'nm',
      code: 'NM',
      name: 'New Mexico',
      tier: 'lagging',
      accessPercent: 54,
      participationPercent: 3.3,
      reportUrl:
        'https://drive.google.com/file/d/1uU0AqPDX0qzSpTji3kL8PUjUtaIZOW8M/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1NTg2whkWc0lkUwSNNPoQ2qbs23jNgUV7ZB3_usFha6s/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ny',
      code: 'NY',
      name: 'New York',
      tier: 'lagging',
      accessPercent: 50,
      participationPercent: 3.1,
      reportUrl:
        'https://drive.google.com/file/d/1NcE3Ww1lQnbAIkcBBV2mGcKxcZF0yBPi/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1cDa3cLjc-IezXB1MphBgjq9W4E3GPKWA2C25qhFxSoE/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'nc',
      code: 'NC',
      name: 'North Carolina',
      tier: 'leading',
      accessPercent: 70,
      participationPercent: 5.7,
      reportUrl:
        'https://drive.google.com/file/d/1I-jd1JwjUJStrhp2FUuNiTRf7r1Mxq8a/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1Kp5tfegio0EVnMsq2DTjSl6Pktqnf4148yvkp3TV-18/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'nd',
      code: 'ND',
      name: 'North Dakota',
      tier: 'leading',
      accessPercent: 84,
      participationPercent: 16.1,
      reportUrl:
        'https://drive.google.com/file/d/1vSGKtb3cnbXNNjr15ImPH91CaYCkAWvX/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1ZQ_c7OBB3aOsdfTL8ztTSVI26-csszkiAE0PAnqWZYw/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'oh',
      code: 'OH',
      name: 'Ohio',
      tier: 'progressing',
      accessPercent: 61,
      participationPercent: 3,
      reportUrl:
        'https://drive.google.com/file/d/1sOaSkqxy1M5WFu8abUTd0ZSZCBONOJfj/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1UnBVOSSYtkiIRpT1GavQqa5YFCcafSymS7YFxPJzA4s/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ok',
      code: 'OK',
      name: 'Oklahoma',
      tier: 'progressing',
      accessPercent: 72,
      participationPercent: 7.6,
      reportUrl:
        'https://drive.google.com/file/d/1vJHobRwDkiyanFhxBZaFsdD2pWFgTDBU/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1xyqPQe5SUkcf7sxuSC0DzpmIroLSNRnt2KMdOTmditg/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'or',
      code: 'OR',
      name: 'Oregon',
      tier: 'lagging',
      accessPercent: 56,
      participationPercent: 6.9,
      reportUrl:
        'https://drive.google.com/file/d/1D6i3fnyxRx7sTQt_WOqtz_sfm1T2YrE-/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/11pWZOT9CzWeXfAn7WO-xxmPocmkInCVB7HuyZZBG4CE/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'pa',
      code: 'PA',
      name: 'Pennsylvania',
      tier: 'progressing',
      accessPercent: 77,
      participationPercent: 3.5,
      reportUrl:
        'https://drive.google.com/file/d/16g-f8ihthdtXO9kpCluljkGTpHE5djLK/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1Oz9OyNT5cJwuYr3g5sBOe0X3uMouinGHXOw_xvlI1D4/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ri',
      code: 'RI',
      name: 'Rhode Island',
      tier: 'leading',
      accessPercent: 79,
      participationPercent: 18.4,
      reportUrl:
        'https://drive.google.com/file/d/1PAWoZpYcNQfn7CBEJNSgOk0rf5z1WABk/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1ZNvSvG9Zv4jkmhLawZwSy043B0Nm_KF5jHRhjBkXD-k/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'sc',
      code: 'SC',
      name: 'South Carolina',
      tier: 'leading',
      accessPercent: 92,
      participationPercent: 25.7,
      reportUrl:
        'https://drive.google.com/file/d/1FkqLHFWo1gGSrSwSMj4Ja_4SDPyg6wTC/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1FFmkI0GzCfk6h3sG5FuVySTFbTzKw3sPlVqBQqZjWTQ/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'sd',
      code: 'SD',
      name: 'South Dakota',
      tier: 'lagging',
      accessPercent: 54,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1zIEDRWOt2plIPkF5dJ6dS6HkNWvUknln/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1TzkKaw6xw9b-D_NmgjWcXWdX7ScdnmpwkpAPal7JBdY/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'tn',
      code: 'TN',
      name: 'Tennessee',
      tier: 'leading',
      accessPercent: 83,
      participationPercent: 13.2,
      reportUrl:
        'https://drive.google.com/file/d/13ZBvS9dV0Xfay1FhgOz_LephGpy2sWwP/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1p4OPWjJNmOv1ZEUfriOQMZ3Njk99qtHCs4ADlsvse6U/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'tx',
      code: 'TX',
      name: 'Texas',
      tier: 'lagging',
      accessPercent: 48,
      participationPercent: 5.1,
      reportUrl:
        'https://drive.google.com/file/d/14CpjdRdA2aDbqTnjGlEePoza6Kufx2RE/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/16nfV7epJyVRHFJVoOnt516Q7xCjs2EDmktl4TCjyf-k/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'ut',
      code: 'UT',
      name: 'Utah',
      tier: 'progressing',
      accessPercent: 82,
      participationPercent: 11.4,
      reportUrl:
        'https://drive.google.com/file/d/13w_csBcxByqKCZLH12E4hADzxm8cqVCC/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1vq2SaA8fHeWyPeFUKvNR7b826DLBK44SFmeY4XpDVJM/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'vt',
      code: 'VT',
      name: 'Vermont',
      tier: 'lagging',
      accessPercent: 60,
      participationPercent: 3.1,
      reportUrl:
        'https://drive.google.com/file/d/1jn2eXmcHDNDfeRLYm-FCwgEgEm26HTvY/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1MOn_S5JoEWxzXed_Ha4zTdkao1JMg8xq1LN1u8webqI/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'va',
      code: 'VA',
      name: 'Virginia',
      tier: 'progressing',
      accessPercent: 68,
      participationPercent: 4.9,
      reportUrl:
        'https://drive.google.com/file/d/1ISlUlcF17xKJcLaDqGgLNnwbB0NjGEm-/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1blwJTj96sFB6Y53X_xsv4GlSk_vuYoJV5ZjYA8OfjGk/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'wa',
      code: 'WA',
      name: 'Washington',
      tier: 'lagging',
      accessPercent: 51,
      participationPercent: 4.5,
      reportUrl:
        'https://drive.google.com/file/d/1E1c6N4jeKeGhQDS65nvSYncqcXvTWsu9/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/16dHyQUwpxnrbEc75pP3iOhYfjVk9CQ0JdnzglwXCVP8/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'wv',
      code: 'WV',
      name: 'West Virginia',
      tier: 'progressing',
      accessPercent: 78,
      participationPercent: 2.7,
      reportUrl:
        'https://drive.google.com/file/d/1XHJnD65DN7LDpGfwYxAnuevhw6ku0f8S/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1YZV91h1Xa433QSBz2Ssj0BMXJlDIDSm0ObQFiJQeFRo/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'wi',
      code: 'WI',
      name: 'Wisconsin',
      tier: 'lagging',
      accessPercent: 54,
      participationPercent: 3.2,
      reportUrl:
        'https://drive.google.com/file/d/1omMaJ94srFvSr_djCNFnx0JGkFzZgumC/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1282Od8zkkiGXki0spGh42V0vOzom8sRzVxFTPepUQ3Q/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'wy',
      code: 'WY',
      name: 'Wyoming',
      tier: 'progressing',
      accessPercent: 64,
      participationPercent: 6.7,
      reportUrl:
        'https://drive.google.com/file/d/1zRWQg6qnBKxQzGKBeWxmr0ZnBWPUK2PB/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1nl6lO6IAD_tXwpH7b5QlaS4A2hkVYZAnXFoYl1VOmfE/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
    {
      id: 'dc',
      code: 'DC',
      name: 'Washington, D.C.',
      tier: 'lagging',
      accessPercent: 60,
      participationPercent: 0,
      dataStatus: 'unavailable',
      reportUrl:
        'https://drive.google.com/file/d/1SjdCE_SqgUZaQIsDHNpAURdzSw6LK5C8/view?usp=sharing',
      presentationUrl:
        'https://docs.google.com/presentation/d/1MLmmcuNjOtGIUlP-qZ8kgoeNW3l11VKmrJe6eZEdCJ8/copy',
      isSelectable: true,
      displayRegion: 'contiguous',
    },
  ],
};
